"use client"

import { useState, useContext, useEffect } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import {
  TextField,
  Button,
  Typography,
  Box,
  MenuItem,
  FormControl,
  Select,
  Autocomplete,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Modal,
  Divider,
  Stack,
  Checkbox,
  Card,
  CardContent,
  Grid,
  Paper,
  alpha,
  InputAdornment,
  Chip,
  Alert,
  Fade,
  useTheme,
  Tooltip,
} from "@mui/material"

import { Close as CloseIcon } from "@mui/icons-material"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import DeleteIcon from "@mui/icons-material/Delete"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import PaymentIcon from "@mui/icons-material/Payment"
import CategoryIcon from "@mui/icons-material/Category"
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn"
import BusinessIcon from "@mui/icons-material/Business"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import PersonIcon from "@mui/icons-material/Person"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import DescriptionIcon from "@mui/icons-material/Description"
import SaveIcon from "@mui/icons-material/Save"

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { registerLocale } from "react-datepicker"
import { es } from "date-fns/locale/es"

registerLocale("es", es)

const GestionTransaccionComponent = () => {
  const theme = useTheme()
  const {
    monedas,
    getMoneda,
    tipoTransaccion,
    getTipoTransaccion,
    tipoMedioDePago,
    getTipoMedioDePago,
    subCategoriaTransaccion,
    getSubCategoriaTransaccion,
    ubicaciones,
    getUbicacion,
    negocios,
    getNegocio,
    item,
    getItem,
    postTransaccionItem,
    postTransaccion,
    getMedioDePagoIdTipoEspecifico,
    medioDePagoIdTipoEspecifico,
    entidadesClientesTresLetras,
    getEntidadesClientesTresLetras,
    getUsuario,
    usuarios,
    postCrearPago,
    postCuentaCorriente,
    getCuentaCorriente,
    updateCuentaCorriente,
    postTransaccionPago,
    categoriaTransaccion,
    getCategoriaTransaccion,
    isNavbarCollapsed,
  } = useContext(ErpContext)

  const [idMoneda, setIdMoneda] = useState("")
  const [idTipoTransaccion, setIdTipoTransaccion] = useState("")
  const [idMedioPago, setIdMedioPago] = useState("")
  const [idEntidad, setIdEntidad] = useState("")
  const [idSubCategoriaTransaccion, setIdSubCategoriaTransaccion] = useState("")
  const [idUbicacion, setIdUbicacion] = useState("")
  const [idNegocio, setIdNegocio] = useState("")
  const [cotizacionTransaccion, setCotizacionTransaccion] = useState("")
  const [descripcionTransaccion, setDescripcionTransaccion] = useState("")
  const [montoTransaccion, setMontoTransaccion] = useState("")
  const [fecha, setFecha] = useState(null)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)

  // VARIABLES PARA MEDIOS DE PAGO
  const [selectedTipoMedioDePago, setSelectedTipoMedioDePago] = useState(null)
  const [selectedMedioDePago, setSelectedMedioDePago] = useState(null)
  const [mostrarButtonModalMedioPago, setMostrarButtonModalMedioPago] = useState(false)
  const [openModalMedioPago, setOpenModalMedioPago] = useState(false)
  const [medioDePagoList, setMedioDePagoList] = useState([])
  const [modalTipoMedioDePagoSeleccionado, setModalTipoMedioDePagoSeleccionado] = useState(null)
  const [modalMedioDePagoSeleccionadoID, setModalMedioDePagoSeleccionadoID] = useState(null)
  const [modalMedioDePagoSeleccionado, setModalMedioDePagoSeleccionado] = useState(null)
  const [modalMedioDePagoCantidad, setModalMedioDePagoCantidad] = useState(null)
  const [cantidaMedioDePagoList, setCantidaMedioDePagoList] = useState(0)

  // VARIABLES PARA ENTIDAD
  const [searchTextCliente, setSearchTextCliente] = useState("")
  const [dniCliente, setDniCliente] = useState([])
  const [aplicarCuentaCorriente, setAplicarCuentaCorriente] = useState(false)

  // VARIABLES PARA USUARIO
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState([])

  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("")

  const handleChange = (setter) => (e) => {
    setter(e.target.value)
  }

  const handleChangeSubCategoria = (setter) => (event) => {
    const selectedSubCatId = event.target.value
    setter(selectedSubCatId)

    // Encuentra la subcategoría seleccionada
    const selectedSubCat = subCategoriaTransaccion.find((subCat) => subCat.id === selectedSubCatId)

    // Encuentra la categoría asociada (tipoTransaccion)
    const associatedCategory = categoriaTransaccion.find((cat) => cat.id === selectedSubCat?.idCategoriaTransaccion)

    // Actualiza la categoría seleccionada
    setCategoriaSeleccionada(associatedCategory?.descripcion || "Desconocida")
  }

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setLoading(true)
    try {
      await getMoneda()
      await getTipoTransaccion()
      await getTipoMedioDePago()
      await getSubCategoriaTransaccion()
      await getUbicacion()
      await getNegocio()
      await getUsuario()
      await getCategoriaTransaccion()
    } catch (err) {
      console.error("Error al cargar datos:", err)
      setError("No se pudieron cargar los datos. Intente nuevamente.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (selectedTipoMedioDePago) {
      if (selectedTipoMedioDePago.id === 7) {
        setMostrarButtonModalMedioPago(true)
        setOpenModalMedioPago(true)
      } else {
        getMedioDePagoIdTipoEspecifico(selectedTipoMedioDePago)
        setMostrarButtonModalMedioPago(false)
      }
    } else {
      setOpenModalMedioPago(false)
      setMedioDePagoList([])
    }

    if (modalTipoMedioDePagoSeleccionado) {
      getMedioDePagoIdTipoEspecifico(modalTipoMedioDePagoSeleccionado)
    }
  }, [selectedTipoMedioDePago, modalTipoMedioDePagoSeleccionado])

  useEffect(() => {
    if (searchTextCliente.length >= 3) {
      getEntidadesClientesTresLetras(searchTextCliente, null)
    }
  }, [searchTextCliente])

  const handleTransaccionSubmit = async (e) => {
    e.preventDefault()

    // Validaciones
    if (
      !dniCliente.id ||
      !usuarioSeleccionado.id ||
      !idNegocio ||
      !idUbicacion ||
      !idTipoTransaccion ||
      !montoTransaccion ||
      !descripcionTransaccion
    ) {
      setError("Por favor complete todos los campos obligatorios")
      return
    }

    setLoading(true)
    try {
      let cuentaCorrienteSumaResta = ""
      // *HARDCODED*
      if (idTipoTransaccion == 4) {
        cuentaCorrienteSumaResta = "compra" //esto esta asi porque en la logica del backend compra siempre suma en cuenta corriente
      }
      if (idTipoTransaccion == 5) {
        cuentaCorrienteSumaResta = "venta" //esto esta asi porque en la logica del backend venta siempre resta en cuenta corriente
      }

      let descripcionFinal = descripcionTransaccion

      //*Hardcoded*
      const transaccionResponse = await postTransaccion(
        montoTransaccion, //montoTotal
        idTipoTransaccion, //idTipoTransaccion
        dniCliente.id, //idEntidad
        idSubCategoriaTransaccion, //idSubCategoriaTransaccion
        descripcionFinal, //descripcion
        usuarioSeleccionado.id, //idUsuario
        idUbicacion, //idUbicacion
        idNegocio, //idNegocio
        0, // montoDescuento en el total
        0, // porcentajeDescuento en el total
        null, // transaccionAsociada
        null, // fecha
        aplicarCuentaCorriente // afectaCuentaCorriente
      )

      const idTransaccion = transaccionResponse.data.id

      if (selectedTipoMedioDePago.id == 7) {
        for (const it of medioDePagoList) {
          const transaccionCrearPago = await postCrearPago(
            1, //idMoneda
            1, //cotizacion
            it.id, //idMedioPago
            it.monto, //moton a pagar x medio de pago
          )

          const idTransaccionCrearPago = transaccionCrearPago.data.id

          await postTransaccionPago(idTransaccion, idTransaccionCrearPago)
        }
      } else {
        const transaccionCrearPago = await postCrearPago(
          1, //idMoneda
          1, //cotizacion
          selectedMedioDePago.id, //idMedioPago
          montoTransaccion, //moton a pagar x medio de pago
        )
        const idTransaccionCrearPago = transaccionCrearPago.data.id

        await postTransaccionPago(idTransaccion, idTransaccionCrearPago)
      }

      // *Hardcoded*
      if (aplicarCuentaCorriente) {
        await updateCuentaCorriente(
          dniCliente.id, //idEntidad
          montoTransaccion, //moton a pagar x medio de pago
          cuentaCorrienteSumaResta,
        )
      }

      // Reiniciar los estados del formulario
      setIdNegocio("")
      setIdUbicacion("")
      setFecha(null)
      setIdMoneda("")
      setIdTipoTransaccion("")
      setIdSubCategoriaTransaccion("")
      setMontoTransaccion("")
      setCotizacionTransaccion("")
      setDescripcionTransaccion("")
      setUsuarioSeleccionado(null)
      setDniCliente(null)
      setAplicarCuentaCorriente(false)
      setMedioDePagoList([])
      setSelectedTipoMedioDePago(null)
      setSelectedMedioDePago(null)
      setCategoriaSeleccionada("")

      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
    } catch (error) {
      console.error("Error al crear transacción:", error)
      setError("No se pudo crear la transacción. Intente nuevamente.")
    } finally {
      setLoading(false)
    }
  }

  const handleAbrirModalMedioDePago = () => {
  }

  const handleCloseModalMedioDePago = () => {
  }

  const handleAddNuevoMedioDePago = () => {
    if (modalMedioDePagoSeleccionado && modalMedioDePagoCantidad) {
      const newMedioDePago = {
        id: modalMedioDePagoSeleccionadoID,
        descripcion: modalMedioDePagoSeleccionado,
        monto: Number.parseFloat(modalMedioDePagoCantidad),
        tipoMedioDePago: modalTipoMedioDePagoSeleccionado.id,
      }

      setMedioDePagoList([...medioDePagoList, newMedioDePago])

      const updatedTotalMedioPagoList = [...medioDePagoList, newMedioDePago].reduce(
        (total, item) => total + item.monto,
        0,
      )

      setCantidaMedioDePagoList(updatedTotalMedioPagoList)
      setModalMedioDePagoSeleccionado("")
      setModalMedioDePagoSeleccionadoID(null)
      setModalMedioDePagoCantidad("")
    }
  }

  const handleDeleteMedioDePago = (medioDePago, medioDePagoMonto) => {
    setCantidaMedioDePagoList((prevTotal) => prevTotal - medioDePagoMonto)
    setMedioDePagoList(medioDePagoList.filter((_, i) => i !== medioDePago))
  }

  return (
    <Box sx={{ p: 2, maxWidth: 1200, mx: "auto" }}>
      {/* Encabezado */}
      <Card elevation={3} sx={{ mb: 1.5, borderRadius: 3 }}>
        <CardContent sx={{ p: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <ReceiptLongIcon
              sx={{
                fontSize: 24,
                color: "rgb(244, 147, 14)",
                mr: 2,
              }}
            />
            <Typography variant="h5" component="h1" sx={{ fontWeight: 600, color: "#2c3e50" }}>
              Gestión de Transacciones
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary">
            Complete todos los campos para crear una nueva transacción en el sistema
          </Typography>
        </CardContent>
      </Card>

      <form onSubmit={handleTransaccionSubmit}>
        <Grid container spacing={2}>
          {/* Sección 1: Información de Entidades y Usuarios */}
          <Grid item xs={12}>
            <Card elevation={2} sx={{ borderRadius: 3 }}>
              <CardContent sx={{ p: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    color: "#2c3e50",
                    fontWeight: 600,
                  }}
                >
                  <PersonIcon sx={{ mr: 1.5, color: "rgb(244, 147, 14)" }} />
                  Información de Entidades y Usuarios
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Entidad *
                      </Typography>
                      <Autocomplete
                        size="small"
                        disablePortal
                        options={entidadesClientesTresLetras.map((it) => ({
                          label: `${it.descripcion} - ${it.apellido} - ${it.dniCuitCuil}`,
                          descripcion: it.descripcion,
                          dniCuitCuil: it.dniCuitCuil,
                          id: it.id,
                        }))}
                        value={dniCliente}
                        onChange={(event, newValue) => {
                          setDniCliente(newValue)
                        }}
                        onInputChange={(event, newInputValue) => setSearchTextCliente(newInputValue)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Buscar entidad..."
                            required
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <>
                                  <InputAdornment position="start">
                                    <PersonIcon color="action" />
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                              },
                            }}
                          />
                        )}
                      />
                      <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                        <Checkbox
                          checked={aplicarCuentaCorriente}
                          onChange={(e) => setAplicarCuentaCorriente(e.target.checked)}
                          size="small"
                        />
                        <Typography variant="body2" color="text.secondary">
                          Afecta la cuenta corriente
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Usuario *
                      </Typography>
                      <Autocomplete
                        size="small"
                        disablePortal
                        options={usuarios.map((it) => ({
                          label: `${it.usuario} - ${it.nombre} - ${it.apellido}`,
                          nombre: it.nombre,
                          apellido: it.apellido,
                          id: it.id,
                          usuario: it.usuario,
                        }))}
                        value={usuarioSeleccionado}
                        onChange={(event, newValue) => {
                          setUsuarioSeleccionado(newValue)
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Seleccionar usuario..."
                            required
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <>
                                  <InputAdornment position="start">
                                    <AccountCircleIcon color="action" />
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                              },
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Sección 2: Negocio, Ubicación y Fecha */}
          <Grid item xs={12}>
            <Card elevation={2} sx={{ borderRadius: 3 }}>
              <CardContent sx={{ p: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    color: "#2c3e50",
                    fontWeight: 600,
                  }}
                >
                  <BusinessIcon sx={{ mr: 1.5, color: "rgb(244, 147, 14)" }} />
                  Información de Negocio y Ubicación
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Negocio *
                      </Typography>
                      <FormControl fullWidth size="small">
                        <Select
                          value={idNegocio}
                          onChange={handleChange(setIdNegocio)}
                          required
                          displayEmpty
                          size="small"
                          startAdornment={
                            <InputAdornment position="start">
                              <BusinessIcon color="action" fontSize="small" />
                            </InputAdornment>
                          }
                          sx={{
                            borderRadius: 2,
                          }}
                        >
                          <MenuItem value="" disabled>
                            Seleccionar negocio
                          </MenuItem>
                          {negocios.map((negocio) => (
                            <MenuItem key={negocio.id} value={negocio.id}>
                              {negocio.descripcion}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Ubicación *
                      </Typography>
                      <FormControl fullWidth size="small">
                        <Select
                          value={idUbicacion}
                          onChange={handleChange(setIdUbicacion)}
                          required
                          displayEmpty
                          size="small"
                          startAdornment={
                            <InputAdornment position="start">
                              <LocationOnIcon color="action" fontSize="small" />
                            </InputAdornment>
                          }
                          sx={{
                            borderRadius: 2,
                          }}
                        >
                          <MenuItem value="" disabled>
                            Seleccionar ubicación
                          </MenuItem>
                          {ubicaciones.map((ubi) => (
                            <MenuItem key={ubi.id} value={ubi.id}>
                              {ubi.descripcion}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Fecha
                      </Typography>
                      <Box
                        sx={{
                          border: `1px solid ${alpha(theme.palette.text.primary, 0.23)}`,
                          borderRadius: 2,
                          p: 1,
                          display: "flex",
                          alignItems: "center",
                          "&:hover": {
                            borderColor: theme.palette.text.primary,
                          },
                        }}
                      >
                        <CalendarTodayIcon color="action" sx={{ mr: 1 }} />
                        <DatePicker
                          locale="es"
                          selected={fecha}
                          onChange={(newValue) => setFecha(newValue)}
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Selecciona una fecha"
                          className="custom-datepicker"
                          wrapperClassName="datepicker-wrapper"
                          style={{ width: "100%", border: "none", outline: "none" }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Sección 3: Configuración de Transacción */}
          <Grid item xs={12}>
            <Card elevation={2} sx={{ borderRadius: 3 }}>
              <CardContent sx={{ p: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    color: "#2c3e50",
                    fontWeight: 600,
                  }}
                >
                  <CategoryIcon sx={{ mr: 1.5, color: "rgb(244, 147, 14)" }} />
                  Configuración de Transacción
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Moneda
                      </Typography>
                      <FormControl fullWidth size="small">
                        <Select
                          value={idMoneda}
                          onChange={handleChange(setIdMoneda)}
                          displayEmpty
                          size="small"
                          startAdornment={
                            <InputAdornment position="start">
                              <MonetizationOnIcon color="action" fontSize="small" />
                            </InputAdornment>
                          }
                          sx={{ borderRadius: 2 }}
                        >
                          <MenuItem value="" disabled>
                            Seleccionar moneda
                          </MenuItem>
                          {monedas.map((moneda) => (
                            <MenuItem key={moneda.id} value={moneda.id}>
                              {moneda.descripcion}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Tipo de Transacción *
                      </Typography>
                      <FormControl fullWidth size="small">
                        <Select
                          value={idTipoTransaccion}
                          onChange={handleChange(setIdTipoTransaccion)}
                          required
                          displayEmpty
                          size="small"
                          startAdornment={
                            <InputAdornment position="start">
                              <ReceiptLongIcon color="action" fontSize="small" />
                            </InputAdornment>
                          }
                          sx={{ borderRadius: 2 }}
                        >
                          <MenuItem value="" disabled>
                            Seleccionar tipo
                          </MenuItem>
                          {tipoTransaccion
                            .filter((tipoTransac) => ![1, 2, 3].includes(tipoTransac.id))
                            .map((tipoTransac) => (
                              <MenuItem key={tipoTransac.id} value={tipoTransac.id}>
                                {tipoTransac.descripcion}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Subcategoría
                      </Typography>
                      <FormControl fullWidth size="small">
                        <Select
                          value={idSubCategoriaTransaccion}
                          onChange={handleChangeSubCategoria(setIdSubCategoriaTransaccion)}
                          displayEmpty
                          size="small"
                          startAdornment={
                            <InputAdornment position="start">
                              <CategoryIcon color="action" fontSize="small" />
                            </InputAdornment>
                          }
                          sx={{ borderRadius: 2 }}
                        >
                          <MenuItem value="" disabled>
                            Seleccionar subcategoría
                          </MenuItem>
                          {subCategoriaTransaccion.map((subCat) => (
                            <MenuItem key={subCat.id} value={subCat.id}>
                              {subCat.descripcion}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {categoriaSeleccionada && (
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
                          Categoría Asociada: <Chip size="small" label={categoriaSeleccionada} />
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Sección 4: Medios de Pago */}
          <Grid item xs={12}>
            <Card elevation={2} sx={{ borderRadius: 3 }}>
              <CardContent sx={{ p: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    color: "#2c3e50",
                    fontWeight: 600,
                  }}
                >
                  <PaymentIcon sx={{ mr: 1.5, color: "rgb(244, 147, 14)" }} />
                  Configuración de Medios de Pago
                </Typography>

                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={4}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Tipo de Medio de Pago *
                      </Typography>
                      <Autocomplete
                        size="small"
                        disablePortal
                        options={tipoMedioDePago}
                        getOptionLabel={(option) => option.descripcion}
                        value={selectedTipoMedioDePago}
                        onChange={(event, newValue) => {
                          setSelectedTipoMedioDePago(newValue)
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Seleccionar tipo..."
                            required
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <>
                                  <InputAdornment position="start">
                                    <PaymentIcon color="action" />
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                              },
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    {!mostrarButtonModalMedioPago && selectedTipoMedioDePago && (
                      <Box sx={{ mb: 1 }}>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                          Medio de Pago *
                        </Typography>
                        <Autocomplete
                          size="small"
                          disablePortal
                          options={medioDePagoIdTipoEspecifico}
                          getOptionLabel={(option) => option.descripcion}
                          value={selectedMedioDePago || ""}
                          onChange={(event, newValue) => {
                            setSelectedMedioDePago(newValue)
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Seleccionar medio..."
                              required
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <>
                                    <InputAdornment position="start">
                                      <PaymentIcon color="action" />
                                    </InputAdornment>
                                    {params.InputProps.startAdornment}
                                  </>
                                ),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: 2,
                                },
                              }}
                            />
                          )}
                        />
                      </Box>
                    )}
                  </Grid>

                  <Grid item xs={12} md={4}>
                    {mostrarButtonModalMedioPago && (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Tooltip title="Configurar múltiples medios de pago">
                          <Button
                            variant="outlined"
                            onClick={handleAbrirModalMedioDePago}
                            startIcon={<AddCircleOutlineIcon />}
                            sx={{
                              borderColor: "rgb(244, 147, 14)",
                              color: "rgb(244, 147, 14)",
                              "&:hover": {
                                backgroundColor: alpha("rgb(244, 147, 14)", 0.1),
                                borderColor: "rgb(244, 147, 14)",
                              },
                              borderRadius: 2,
                            }}
                          >
                            Configurar Pagos
                          </Button>
                        </Tooltip>
                        {medioDePagoList.length > 0 && (
                          <Chip
                            label={`${medioDePagoList.length} medios configurados`}
                            color="primary"
                            variant="outlined"
                          />
                        )}
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Sección 5: Detalles de la Transacción */}
          <Grid item xs={12}>
            <Card elevation={2} sx={{ borderRadius: 3 }}>
              <CardContent sx={{ p: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    color: "#2c3e50",
                    fontWeight: 600,
                  }}
                >
                  <DescriptionIcon sx={{ mr: 1.5, color: "rgb(244, 147, 14)" }} />
                  Detalles de la Transacción
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Monto *
                      </Typography>
                      <TextField
                        size="small"
                        type="number"
                        placeholder="Ingrese el monto..."
                        variant="outlined"
                        fullWidth
                        value={montoTransaccion}
                        onChange={(e) => setMontoTransaccion(e.target.value)}
                        required
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <MonetizationOnIcon color="action" />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Cotización
                      </Typography>
                      <TextField
                        size="small"
                        type="number"
                        placeholder="Ingrese la cotización..."
                        variant="outlined"
                        fullWidth
                        value={cotizacionTransaccion}
                        onChange={(e) => setCotizacionTransaccion(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <MonetizationOnIcon color="action" />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                        Descripción *
                      </Typography>
                      <TextField
                        size="small"
                        placeholder="Ingrese una descripción detallada..."
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={3}
                        value={descripcionTransaccion}
                        onChange={(e) => setDescripcionTransaccion(e.target.value)}
                        required
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" sx={{ alignSelf: "flex-start", mt: 1.5 }}>
                              <DescriptionIcon color="action" />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Botón de envío */}
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
              <Button
                variant="contained"
                type="submit"
                disabled={loading}
                startIcon={<SaveIcon />}
                size="large"
                sx={{
                  borderRadius: 3,
                  textTransform: "none",
                  boxShadow: 3,
                  py: 1,
                  px: 6,
                  fontSize: "1rem",
                  fontWeight: 600,
                  backgroundColor: "#5b5b5f",
                  "&:hover": {
                    backgroundColor: alpha("#5b5b5f", 0.9),
                    transform: "translateY(-2px)",
                    boxShadow: 4,
                  },
                  "&:disabled": {
                    backgroundColor: alpha("#5b5b5f", 0.6),
                  },
                  transition: "all 0.3s ease",
                }}
              >
                {loading ? "Creando Transacción..." : "Crear Transacción"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>

      {/* Alertas */}
      <Fade in={success}>
        <Alert
          severity="success"
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            zIndex: 9999,
            borderRadius: 2,
            boxShadow: 3,
          }}
          onClose={() => setSuccess(false)}
        >
          Transacción creada correctamente
        </Alert>
      </Fade>

      {error && (
        <Alert
          severity="error"
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            zIndex: 9999,
            borderRadius: 2,
            boxShadow: 3,
          }}
          onClose={() => setError(null)}
        >
          {error}
        </Alert>
      )}

      {/* Modal de Medios de Pago */}
      <Modal open={openModalMedioPago} onClose={handleCloseModalMedioDePago}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 480,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 0,
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              p: 2,
              backgroundColor: "#5b5b5f",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }}>
              <PaymentIcon sx={{ mr: 1 }} /> Selección de Medios de Pago
            </Typography>
            <IconButton onClick={handleCloseModalMedioDePago} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ p: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  disablePortal
                  options={tipoMedioDePago}
                  getOptionLabel={(option) => option.descripcion}
                  value={modalTipoMedioDePagoSeleccionado}
                  onChange={(event, newValue) => setModalTipoMedioDePagoSeleccionado(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tipo de medio de pago"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <InputAdornment position="start">
                              <CategoryIcon color="action" />
                            </InputAdornment>
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Autocomplete
                  disablePortal
                  options={medioDePagoIdTipoEspecifico.map((it) => ({
                    label: it.descripcion,
                    id: it.id,
                  }))}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setModalMedioDePagoSeleccionado(newValue.label)
                      setModalMedioDePagoSeleccionadoID(newValue.id)
                    } else {
                      setModalMedioDePagoSeleccionado(null)
                      setModalMedioDePagoSeleccionadoID(null)
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Medio de Pago"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <InputAdornment position="start">
                              <PaymentIcon color="action" />
                            </InputAdornment>
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <TextField
                    label="Cantidad a pagar"
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={modalMedioDePagoCantidad}
                    onChange={(e) => setModalMedioDePagoCantidad(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MonetizationOnIcon color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Tooltip title="Agregar medio de pago">
                    <IconButton
                      onClick={handleAddNuevoMedioDePago}
                      sx={{
                        color: "rgb(244, 147, 14)",
                        backgroundColor: alpha("rgb(244, 147, 14)", 0.1),
                        "&:hover": {
                          backgroundColor: alpha("rgb(244, 147, 14)", 0.2),
                        },
                      }}
                    >
                      <AddCircleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>

            {/* Totales y validaciones */}
            <Box
              sx={{
                backgroundColor: alpha(theme.palette.background.default, 0.5),
                borderRadius: 2,
                padding: 2,
                boxShadow: 1,
                mt: 3,
              }}
            >
              <Stack spacing={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="subtitle1" fontWeight="bold">
                    TOTAL
                  </Typography>
                  <Typography variant="subtitle1">
                    {new Intl.NumberFormat("es-AR", {
                      style: "currency",
                      currency: "ARS",
                    }).format(montoTransaccion || 0)}
                  </Typography>
                </Box>

                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="subtitle1" fontWeight="bold">
                    CANTIDAD POR PAGOS
                  </Typography>
                  <Typography variant="subtitle1">
                    {new Intl.NumberFormat("es-AR", {
                      style: "currency",
                      currency: "ARS",
                    }).format(cantidaMedioDePagoList || 0)}
                  </Typography>
                </Box>

                <Divider />

                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="subtitle1" fontWeight="bold">
                    RESTANTE
                  </Typography>
                  {montoTransaccion !== cantidaMedioDePagoList && (
                    <Typography variant="body2" color="error.main" fontWeight="bold">
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format((montoTransaccion || 0) - cantidaMedioDePagoList)}
                    </Typography>
                  )}
                  {montoTransaccion === cantidaMedioDePagoList && (
                    <Typography variant="body2" color="success.main" fontWeight="bold">
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(0)}
                    </Typography>
                  )}
                </Box>
              </Stack>
            </Box>

            {/* Lista de medios de pago seleccionados */}
            <Typography
              variant="subtitle1"
              sx={{
                mt: 3,
                mb: 1,
                fontWeight: 500,
              }}
            >
              Medios de Pago Seleccionados
            </Typography>

            <Paper
              elevation={0}
              sx={{
                maxHeight: 200,
                overflowY: "auto",
                backgroundColor: alpha(theme.palette.background.default, 0.5),
                borderRadius: 2,
              }}
            >
              <List dense>
                {medioDePagoList.length > 0 ? (
                  medioDePagoList.map((it, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        mb: 1,
                        backgroundColor: "white",
                        borderRadius: 1,
                        boxShadow: 1,
                      }}
                    >
                      <ListItemText
                        primary={it.descripcion}
                        secondary={new Intl.NumberFormat("es-AR", {
                          style: "currency",
                          currency: "ARS",
                        }).format(it.monto)}
                      />
                      <ListItemSecondaryAction>
                        <IconButton
                          edge="end"
                          onClick={() => handleDeleteMedioDePago(index, it.monto)}
                          sx={{ color: theme.palette.error.main }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))
                ) : (
                  <ListItem>
                    <ListItemText
                      primary={
                        <Typography color="text.secondary" align="center">
                          No hay medios de pago seleccionados
                        </Typography>
                      }
                    />
                  </ListItem>
                )}
              </List>
            </Paper>
          </Box>
        </Box>
      </Modal>
    </Box>
  )
}

export default GestionTransaccionComponent